interface ShowViewMoreArgs {
  loading: boolean;
  success: boolean;
  itemCount: number;
  pageSize: number;
  totalCount: number;
  hasMore: boolean;
}

export const shouldShowPreviewViewMore = ({
  loading,
  success,
  itemCount,
  pageSize,
  totalCount,
  hasMore,
}: ShowViewMoreArgs) => {
  if (loading || !success) return false;
  if (itemCount < pageSize) return false;
  return hasMore || totalCount > pageSize;
};
